// -----------------------------------------------------------------------------
// Converts image data into a File object (for upload)
//
// Credit: http://www.nixtu.info/2013/06/how-to-upload-canvas-data-to-server.html
// -----------------------------------------------------------------------------
const imageDataToFile = (imageData) => {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(imageData.split(',')[1])

  // separate out the mime component
  var mimeString = imageData.split(',')[0].split(':')[1].split(';')[0]

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length)
  var dw = new DataView(ab)
  for (var i = 0; i < byteString.length; i++) {
    dw.setUint8(i, byteString.charCodeAt(i))
  }

  // write the ArrayBuffer to a blob
  return new Blob([ab], { type: mimeString })
}

module.exports = {
  imageDataToFile
}
